/* eslint-disable */
import {
  fetch30SecondSurveys,
  fetchActivityLogs,
  fetchChildrenInformationForMyPageParent, fetchNumberOfPostsOnSlack,
  fetchSozowCoinCredit,
  fetchSozowCoinSentAndReceivedLogs,
} from "@/services/user";
import {
  ActivityLog,
  SozowCoinCredit,
  SozowCoinSentAndReceivedLog,
  NumberOfPostsOnSlack,
} from "@/types/user";

interface State {
  user: any;
  activityLogs: ActivityLog[] | [];
  sozowCoinCredit: SozowCoinCredit | {};
  sozowCoinSentAndReceivedLogs: SozowCoinSentAndReceivedLog[] | [];
  numberOfPostsOnSlack: NumberOfPostsOnSlack[] | [],
  thirtySecondSurveys: any;
}

const state: State = {
  user: null,
  activityLogs: [],
  sozowCoinCredit: {},
  sozowCoinSentAndReceivedLogs: [],
  numberOfPostsOnSlack: [],
  thirtySecondSurveys: [],
};

const mutations = {
  setUserInformation(state: State, user: any) {
    state.user = user;
  },
  setActivityLogs(state: State, activityLogs: any) {
    state.activityLogs = activityLogs;
  },
  setSozowCoinCredit(state: State, sozowCoinCredit: any) {
    state.sozowCoinCredit = sozowCoinCredit;
  },
  setSozowCoinSentAndReceivedLogs(
    state: State,
    sozowCoinSentAndReceivedLogs: any
  ) {
    state.sozowCoinSentAndReceivedLogs = sozowCoinSentAndReceivedLogs;
  },
  setNumberOfPostsOnSlack(state: State, numberOfPostsOnSlack: any) {
    state.numberOfPostsOnSlack = numberOfPostsOnSlack;
  },
  set30SecondSurveys(state: State, thirtySecondSurveys: any) {
    state.thirtySecondSurveys = thirtySecondSurveys;
  },
};

const actions = {
  async fetchChildrenInformationForMyPageParent({ commit }: any) {
    const response = await fetchChildrenInformationForMyPageParent();

    if (response) {
      commit("setUserInformation", response.data);
    }
  },
  async fetchActivityLogs({ commit }: any, userId: number) {
    const response = await fetchActivityLogs(userId);

    if (response) {
      commit("setActivityLogs", response);
    }
  },
  async fetchSozowCoinCredit({ commit }: any, userId: number) {
    const response = await fetchSozowCoinCredit(userId);

    if (response) {
      commit("setSozowCoinCredit", response);
    }
  },
  async fetchSozowCoinSentAndReceivedLogs({ commit }: any, userId: number) {
    const response = await fetchSozowCoinSentAndReceivedLogs(userId);

    if (response) {
      commit("setSozowCoinSentAndReceivedLogs", response);
    }
  },

  async fetchNumberOfPostsOnSlack({ commit }: any, userId: number) {
    const response = await fetchNumberOfPostsOnSlack(userId);

    if (response) {
      commit("setNumberOfPostsOnSlack", response);
    }
  },

  async fetch30SecondSurveys({ commit }: any, userId: number) {
    const response = await fetch30SecondSurveys(userId);

    if (response) {
      commit("set30SecondSurveys", response);
    }
  },
};

function formatUserInfor(user: any) {
  if (user) {
    const userId = user.user_id;
    const userName = user.user_name;
    const nickName = user.nickname;
    const admissionDate = user.admission_season;
    const mentor = user.name_staff;
    const classGuide = user.class_guide;
    const course = user.current_plan;
    const school = user.member_id;
    const pass = user.pass;
    const minecraftPass = user.minecraft_pass;
    const email = user.email;

    return {
      userId,
      userName,
      nickName,
      admissionDate,
      mentor,
      classGuide,
      course,
      school,
      pass,
      minecraftPass,
      email,
    };
  }

  return {};
}

const getters = {
  formatedUserInfor: (state: State) => {
    return formatUserInfor(state.user);
  },
  getActivityLogs: (state: State) => {
    return state.activityLogs;
  },
  getSozowCoinCredit: (state: State) => {
    return state.sozowCoinCredit;
  },
  getSozowCoinSentAndReceivedLogs: (state: State) => {
    return state.sozowCoinSentAndReceivedLogs;
  },
  getNumberOfPostsOnSlack: (state: State) => {
    return state.numberOfPostsOnSlack;
  },
  get30SecondSurveys: (state: State) => {
    return state.thirtySecondSurveys;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
